// extracted by mini-css-extract-plugin
export var backButton = "hi2OxbV6NnH3miE1WcBD";
export var cardCaption = "GnK3KFllRf6XD7bGG5GZ";
export var cardImage = "usfJoc74a7eGes7yeDpl";
export var cardList = "ST8J9fYbCZ_LjaEVGxcB";
export var cardListItem = "FLNR8EQMUhrPc7DWa6bg";
export var cardSkeleton = "SM0Us_1OVfyKmNPdnD1w";
export var header = "iB3RtO9q_TgL0xasDfhH";
export var headingSkeleton = "cpkTQiCTfh_tc4WqB1CP";
export var itemsCount = "vkFeLxpDpWQ2zfir7O3P";